export interface MessagingEdge {
  id: string;
  label: string;
  source: string;
  target: string;
}

const buildEdge = (
  source: string,
  target: string,
  label: string
): MessagingEdge => {
  return { id: `${source}:${target}`, source, target, label };
}

export const buildWaitQueueEdge = (source: string, target: string): MessagingEdge => {
  return buildEdge(source, target, 'wait to retry');
}

export const buildParkingLotEdge = (source: string, target: string): MessagingEdge => {
  return buildEdge(source, target, 'dead letter');
}

export const buildInputTargetEdge = (source: string, target: string): MessagingEdge => {
  return buildEdge(source, target, 'delivery to');
}

export const buildOutputTargetEdge = (source: string, target: string): MessagingEdge => {
  return buildEdge(source, target, 'consumes from');
}

export const buildInputSourceEdge = (source: string, target: string): MessagingEdge => {
  return buildEdge(source, target, 'produces for');
}

export const buildDelayedEdge = (source: string, target: string): MessagingEdge => {
  return buildEdge(source, target, 'delay for');
}
